<template>
  <div>

    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>调查问卷</el-breadcrumb-item>
    <el-breadcrumb-item>查看调查问卷</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>

<el-table
    ref="multipleTable"
    :data="cloudFileList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      label="问卷标题"
      width="120"
      :show-overflow-tooltip="true"
      prop="survey_name">
      
    </el-table-column>
    <el-table-column
      label="创建时间"
      width="120"
      :show-overflow-tooltip="true"
      prop="create_date">
      
    </el-table-column>
    <el-table-column
      label="状态"
      width="120"
      :show-overflow-tooltip="true"
      :formatter="formatter_survey_state"
      prop="survey_state">
      
    </el-table-column>
 <el-table-column
      label="操作"
      width="350">
        <template slot-scope="scope" >
   <el-button type="info" id="equSN" @click="getCope(scope.row)" :data-clipboard-text="$DWSurveyHtmlUrl+'/static/diaowen/answer-p.html?sid='+scope.row.sid+'&publisher='+teacherId" >复制访问地址</el-button>
   <!-- <el-button  @click="getList()">查看问卷数据</el-button> -->
      <el-button v-if="userType==4"   @click="setRole(scope.row)">设置调查问卷对象</el-button>
      </template>
    </el-table-column>

  </el-table>

  <!-- <div class="block">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div> -->

  </el-card>
  <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  destroy-on-close
  width="30%">

  <el-checkbox-group v-model="updateRoleForm.roleList">
    <el-checkbox label="1"  >学生</el-checkbox>
    <el-checkbox label="0" >老师</el-checkbox>
    <el-checkbox label="3">家长</el-checkbox>
    <el-checkbox label="4">领导</el-checkbox>
    <el-checkbox label="5">辅导员</el-checkbox>
  </el-checkbox-group>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click=" subRoleList()">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard';

export default {
    created(){
    this.getQuestionnaireList()
  },
data(){
    return{
      updateRoleForm:{
        roleList:[],
      id:[],
      },
      dialogVisible:false,
      userType:'',
      total:null,
      currentPage4: 1,
      teacherId:'',
      cloudFileList:[],
      questionnaireList:null,
    }
},
methods:{
    getQuestionnaireList(){
      let user=JSON.parse(localStorage.getItem("user"))
        console.log(user)
        let userId=user.userid
        this.userType=user.type
        this.teacherId=userId
        let subData={
            'userFromId':userId,
            'userFromType':'1'
        }
        this.axios.post("/SurveyDetail/getSurveyDetailList", subData)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.cloudFileList=resp.data.result
               console.log(resp.data.result)
          } else {
            this.$message.error("发生过错误");
            this.loading=false
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });

    },formatter_survey_state(row, column){
      if(row.survey_state==0){
        return "设计状态";
      }else  if(row.survey_state==1){
        return "执行中";
      }else  if(row.survey_state==2){
        return "结束";
      }else{
        return "未知状态"
      }
      },
      subRoleList(){
        this.dialogVisible = false
       console.log(this.updateRoleForm)
       this.axios.post(this.$DWSurveyJarUrl+"/api/publicControl/setRole?roleList="+this.updateRoleForm.roleList+'&id='+this.updateRoleForm.id)
        .then((resp) => {
          if(resp.data==1){
      
            this.getQuestionnaireList()
            this.$message.success("设置成功");
          }
         
        })
        .catch((err) => {
          this.$message.error("出错");
        });

      },
    getCope(data){
     console.log(data)
     var cli=  new Clipboard('#equSN')
     cli.on('success', () => {
        console.log('文本已成功复制到剪贴板');
        cli.destroy();
      });

      cli.on('error', () => {
        console.error('复制文本到剪贴板时发生错误');
        cli.destroy();
      });
    },
    setRole(data){
      var roleList=[]
      this.dialogVisible=true
      console.log(data)
      if(data.role_list!=null&&data.role_list!=''){
        roleList=JSON.parse(data.role_list)
      }
      
      this.updateRoleForm.roleList=roleList
      this.updateRoleForm.id=data.id
    },
    getList(){
      this.axios.get("http://localhost:8081/api/publicControl/list.do?pageSize=10&current=1&surveyId=0d02cec8-0263-4171-b75f-f411277cb2af")
        .then((resp) => {
          this.total=resp.data.total
        console.log(resp.data)
        })
        .catch((err) => {
          this.$message.error("出错");
        });


    },handleSizeChange(val) {
        if(val!=null||val!=''){
          this.querys.pageSize=val
        }
        console.log(`每页 ${val} 条`);
        this.getCloudFiles()
      },
      handleCurrentChange(val) {
        if(val!=null||val!=''){
          this.querys.pageNum=val
        }
        console.log(`当前页: ${val}`);
        this.getCloudFiles()
      }
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/teacher/ViewQuestionnaire.vue